import { jsx as _jsx } from "react/jsx-runtime";
import { MetricCard } from "@/components/ui/MetricCard";
import { formatBytesPrecise, isByteUnit } from "@/utils/formatters";
function formatStatCards(stats) {
    const formattedEntropy = isByteUnit(stats.totalEntropyUnit) ? formatBytesPrecise(stats.totalEntropyServed) : `${stats.totalEntropyServed.toLocaleString()} ${stats.totalEntropyUnit}`;
    return [
        {
            title: "Total Entropy Served",
            value: formattedEntropy,
            subtitle: "Combined across all products"
        },
        {
            title: "Quantum Security Grade",
            value: stats.quantumSecurityGrade,
            subtitle: "TLSvL3 encrypted"
        },
        {
            title: "Active API Keys",
            value: stats.activeApiKeyCount.toLocaleString(),
            subtitle: "Across all products"
        },
        {
            title: "Geographic Footprint",
            value: stats.geographicFootprint.countries.toString(),
            subtitle: `Countries · ${stats.geographicFootprint.continents} continents`
        }
    ];
}
export function DashboardStatCards({ stats, isLoading }) {
    const cards = formatStatCards(stats);
    return /*#__PURE__*/ _jsx("div", {
        className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4",
        children: cards.map((card)=>/*#__PURE__*/ _jsx(MetricCard, {
                helperText: card.subtitle,
                isLoading: isLoading,
                label: card.title,
                value: card.value
            }, card.title))
    });
}
